/**
 * Agent Leaderboard Tour Configuration
 * Introduces users to the leaderboard features
 */

import { TourDefinition } from './tour.types';

export const leaderboardTour: TourDefinition = {
  id: 'leaderboard-tour',
  name: 'Agent Leaderboard',
  page: '/leaderboard',
  version: 2, // Updated tour chain flow
  nextTourId: 'settings-tour', // Chain to settings tour (final tour)
  steps: [
    {
      id: 'leaderboard-intro',
      targetSelector: '[data-tour="leaderboard-header"]',
      title: 'Agent Leaderboard',
      description:
        'Welcome to the leaderboard! See how you and your team rank based on performance metrics like premium, sales, and conversion rates.',
      placement: 'bottom',
    },
    {
      id: 'leaderboard-podium',
      targetSelector: '[data-tour="leaderboard-podium"]',
      title: 'Hall of Champions',
      description:
        'The top 3 performers are displayed here on the podium. Gold, silver, and bronze badges are awarded based on the selected metric.',
      placement: 'bottom',
    },
    {
      id: 'leaderboard-filters',
      targetSelector: '[data-tour="leaderboard-filters"]',
      title: 'Filter & Search',
      description:
        'Filter the leaderboard by time period, metric type, and search for specific agents. Rankings update in real-time!',
      placement: 'bottom',
    },
    {
      id: 'leaderboard-performance',
      targetSelector: '[data-tour="leaderboard-performance"]',
      title: 'Performance Cards',
      description:
        'Quick stats showing overall team performance including total premium, average sales, and top metrics.',
      placement: 'top',
    },
    {
      id: 'leaderboard-table',
      targetSelector: '[data-tour="leaderboard-table"]',
      title: 'Rankings Table',
      description:
        'View detailed rankings for all agents. Click on any column header to sort by that metric.',
      placement: 'top',
    },
  ],
};
